import { ApiService } from '../../ApiService';
import { QualityOfHireAnalytics } from '../../../entities/quality_of_hire/QualityOfHireAnalytics';
import { DateFilter } from '../../../components/DateRangePicker';

export class AnalyticsService {
  public static get(
    filter_selector: string,
    job_names: string[],
    department_names: string[],
    hiring_manager_names: string[],
    recruiter_names: string[],
    dateRange: DateFilter,
    triggers_ids: string[],
    location_names: string[],
  ): Promise<QualityOfHireAnalytics> {
    return ApiService.get<QualityOfHireAnalytics>(
      '/api/quality_of_hire/analytics',
      {
        filter_selector,
        job_names,
        department_names,
        hiring_manager_names,
        recruiter_names,
        start_date: dateRange.start.toJSON(),
        end_date: dateRange.end.toJSON(),
        date_range: dateRange.range,
        triggers_ids,
        location_names,
      },
    );
  }
}
